require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-wiesfleck.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-wiesfleck");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-wiesfleck!./.cache/json/betreuungseinrichtungen-oberwart-wiesfleck.json
// module id = 1030
// module chunks = 231608221292675